// TANDA L / L4.2 (firma de Carlos, 2026-08-08) — EL RECHAZO POR SALDO, UNA SOLA VOZ.
//
// EL HALLAZGO (censo R+S, #20). El backend rechaza por saldo desde CUATRO puertas y las
// cuatro mandan el MISMO sobre —`{error: "insufficient_credits", credits_required,
// credits_available, message}` (documents.py:530, :560, :1246, :1603, :1642, :2492)—
// pero en pantalla sonaban a cuatro productos distintos:
//
//   · el modal de subida pintaba `detail.message` TAL CUAL: prosa en INGLÉS del servidor,
//     también para un usuario en español (Dashboard.js, `insufficient-credits-message`);
//   · el confirmar del documento partido decía "Tus saldos cambiaron. Actualizamos los
//     números." — sin decir CUÁLES números, aunque el 402 los traía en la mano;
//   · el cambio de plan pintaba el `detail` crudo del servidor (PricingPage.js);
//   · y el Reintentar —el ÚNICO correcto— decía "necesitas X, tienes Y", traducido,
//     usando `dashboard:toasts.retry_insufficient_credits_n` (lib/retryErrorToast.js).
//
// LA REGLA QUE DEJA: el que rechaza por saldo habla SIEMPRE con los dos números y en el
// idioma del usuario. Este módulo es esa voz, y no estrena copy: reusa las dos claves que
// el Reintentar ya tenía traducidas en EN y ES. El nombre `retry_*` de esas claves es
// histórico —nacieron en esa superficie— y NO se renombra a propósito: tocarlas obligaría
// a editar la superficie que el encargo declara intocable por ser la referencia.
//
// DEVUELVE `null` cuando el error NO es un rechazo por saldo. Quien llama conserva
// entonces su camino de siempre: así este módulo nunca se traga un error ajeno, y la
// ventana de despliegue (un backend viejo que aún no mande el sobre completo) cae sola al
// comportamiento anterior en vez de inventar números.

/**
 * @param detail  el `err.response.data.detail` del rechazo (objeto o lo que sea)
 * @param t       la `t` de la superficie que llama (necesita el namespace `dashboard`)
 * @returns {string|null} el aviso traducido, o null si esto no es un rechazo por saldo
 */
export function insufficientCreditsCopy(detail, t) {
  if (!detail || typeof detail !== 'object') return null;
  if (detail.error !== 'insufficient_credits') return null;
  const req = detail.credits_required;
  const have = detail.credits_available;
  // Con los DOS números, el aviso los dice. Sin ellos, el copy a secas — un aviso con
  // "undefined" sería peor que uno genérico (la misma frontera que retryErrorToast).
  if (typeof req === 'number' && typeof have === 'number') {
    return t('dashboard:toasts.retry_insufficient_credits_n', { required: req, available: have });
  }
  return t('dashboard:toasts.retry_insufficient_credits');
}

export default insufficientCreditsCopy;
